import { useQuery } from "@tanstack/react-query";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";

export interface AvailableDoor {
  doorNumber: string;
  doorType: string;
  priority: number;
  trailerNumber: string;
  manifestNumber: string;
  doorStatus: string;
  doorUsage: string | null;
  destinationName: string;
}

export const useAvailableDoors = () => {
  const userState = useSelector(userSelector);
  const terminalNumber = userState.activeTerminal?.id;

  const { data, isLoading, isFetching, error } = useQuery<AvailableDoor[]>({
    queryKey: [QUERY_KEYS.AVAILABLE_DOORS, terminalNumber],
    enabled: Boolean(terminalNumber),
    queryFn: async () => {
      const response = await apiQueryAdapter.query<AvailableDoor[]>(
        `/inbound-freight/available-doors`,
        "GET",
        { params: { terminalNumber } }
      );
      return response.data;
    },
  });

  return { data, isLoading, isFetching, error };
};
